import * as Sentry from '@sentry/vue';
import type { App } from 'vue';

export const installSentryPlugin = (app: App) => {
  if (import.meta.env.PROD) {
    Sentry.init({
      app,
      dsn: 'https://58bf84f644199d7b1e840f0baf9cea6d@o1110268.ingest.us.sentry.io/4511179188469760',
      release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
      tracesSampleRate: 1.0,
      environment: 'production',
    });
  }
};
